import {Component, Input} from '@angular/core';
import {MenuElement, MenuElementType7, TileType1} from "../../../models";
import {
    ControlService,
    ParametersService,
    SubtitlesService
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-temperature-sensor',
    templateUrl: './tile-temperature-sensor.component.html',
    styleUrls: ['./tile-temperature-sensor.component.scss']
})
export class TileTemperatureSensorComponent {
    @Input() tile: TileType1;

    constructor(
        private control: ControlService,
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }

    hasTimeValue(elementMenu: MenuElement): boolean {
        return (elementMenu as MenuElementType7).params.timeValue >= 0
    }
}
